/** Cliente ABC */
export interface ClienteAbc {
    id: number;
    nome: string;
}

export const clienteA: ClienteAbc = {id: 1, nome: 'A'};
export const clienteB: ClienteAbc = {id: 2, nome: 'B'};
export const clienteC: ClienteAbc = {id: 3, nome: 'C'};

export const clienteAbcs: ClienteAbc[] = [
    clienteA,
    clienteB,
    clienteC
];
